import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const selectionPreviewPluginKey: PluginKey = new PluginKey('aiExperienceSelectionPreview');
